import React from 'react';
import styles from './StackedBarChart.module.scss';

const StackedBarChart = ({ bars = [] }) => {
  const generalBars = bars.map(el => ({
    name: el.name,
    color: el.color,
    value: parseFloat(el.value.split(",").join("")),
    label: el.value
  }));

  const values = bars.map(bar => parseFloat(bar.value.split(",").join("")));
  const biggest = Math.max(...values);
  const smallest = Math.min(...values);

  const getTotalWidth = (value) => {
    const total = Math.abs(biggest) + Math.abs(smallest);
    return (Math.abs(value) * 100 / total);
  };

  const getWidthStyle = (value) => {
    const aux = value >= 0 ? biggest : Math.abs(smallest);
    const percent = (Math.abs(value) * 100) / aux;
    return percent;
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.chart}
        style={{
          background: `
            repeating-linear-gradient(
              to right,
              rgba(191, 191, 191, 0.25),
              rgba(191, 191, 191, 0.25) 2px,
              rgba(255, 255, 255, 0) 2px,
              rgba(255, 255, 255, 0) ${getTotalWidth(smallest) / 2}%
            )
          `
        }}
      >
        {generalBars.map((bar, index) => (
          <div className="row" key={index}>
            <div
              className={`col-auto ${styles["left-bar"]}`}
              style={{ width: `${getTotalWidth(smallest)}%` }}
            >
              {bar.value < 0 && (
                <div
                  className={styles.bar}
                  style={{
                    backgroundColor: bar.color,
                    color: bar.color,
                    width: `${getWidthStyle(bar.value)}%`
                  }}
                >
                  <div className={styles.label}>
                    S/&nbsp;{Number(bar.label).toLocaleString('es-PE')}&nbsp;M
                  </div>
                </div>
              )}
            </div>
            <div
              className={`col-auto ${styles["right-bar"]}`}
              style={{ width: `${getTotalWidth(biggest)}%` }}
            >
              {bar.value >= 0 && (
                <div
                  className={styles.bar}
                  style={{
                    backgroundColor: bar.color,
                    color: bar.color,
                    width: `${getWidthStyle(bar.value)}%`
                  }}
                >
                  <div className={styles.label}>
                    S/&nbsp;{Number(bar.label).toLocaleString('es-PE')}&nbsp;M
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StackedBarChart;